<div class="group-profile-image">
    <profile-image *ngFor="let image of images" [image]="image"></profile-image>
</div>
